import { render, staticRenderFns } from "./NewsComponent.vue?vue&type=template&id=463aee27&scoped=true&"
import script from "./NewsComponent.vue?vue&type=script&lang=js&"
export * from "./NewsComponent.vue?vue&type=script&lang=js&"
import style0 from "./NewsComponent.vue?vue&type=style&index=0&id=463aee27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463aee27",
  null
  
)

export default component.exports